var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 803.126,
    viewBox: "0 0 430 803.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_100541",
    "data-name": "Path 100541",
    d: "M161.826,191.188c78.035-25.789,89.256-54.516,144.354-82.22,74.507-37.465,122.326-18.8,122.326-3.4v784.61H-1.129s-.822-714.437,0-726.024S83.791,216.977,161.826,191.188Z",
    transform: "translate(1.494 -87.049)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMob);
export default __webpack_public_path__ + "static/media/background_mob.aee447fefe352a541842378996dc7646.svg";
export { ForwardRef as ReactComponent };